import { useGetAllRolesQuery } from "../../../hooks/queries/useRoleQueries";
import { ConfirmModal, RoleModal } from "../modals/RBACModals";
import FetchFeedback from "../../ui/CustomFetchFeedback/CustomFetchFeedback";
import RoleFilters from "./components/roles/RoleFilters";
import RoleTableContent from "./components/roles/RoleTableContent";
import { useRoleFilters } from "../hooks/roles/useRoleFilters";
import { useRoleModal } from "../hooks/roles/useRoleModal";
import { useRoleForm } from "../hooks/roles/useRoleForm";
import { useRolePermissions } from "../hooks/roles/useRolePermissions";
import { useRoleHandlers } from "../hooks/roles/useRoleHandlers";


const RolesTab = () => {
  const {
    data: roles = [],
    isLoading,
    isError,
    refetch,
  } = useGetAllRolesQuery();

  const filterHook = useRoleFilters({ roles });
  const formHook = useRoleForm();
  const modalHook = useRoleModal({ onModalClose: formHook.resetForm });
  const permissionsHook = useRolePermissions();
  const handlerHook = useRoleHandlers({
    modalMode: modalHook.modalMode,
    selectedRole: modalHook.selectedRole,
    closeModal: modalHook.closeModal,
  });

  // Handle edit role - prefill form when editing
  const handleEditRole = (role) => {
    formHook.prefillForm(role);
    modalHook.openEditModal(role);
  };

  // Prepare form submission handler
  const handleSubmit = formHook.handleSubmit(handlerHook.handleSubmit);

  if (isError) {
    return (
      <FetchFeedback
        message="Failed to load roles. Please try again."
        onRetry={refetch}
      />
    );
  }

  return (
    <div className="flex flex-col min-h-full">
      <RoleFilters
        onSearchChange={filterHook.setSearchTerm}
        badgeCount={filterHook.filteredRoles.length}
        onAddRole={modalHook.openCreateModal}
        isCreating={handlerHook.isCreating}
      />

      <div className="flex-1">
        <RoleTableContent
          loadingData={isLoading}
          noRoles={filterHook.noRoles}
          noResults={filterHook.noResults}
          filteredRoles={filterHook.filteredRoles}
          onEdit={handleEditRole}
          onDelete={handlerHook.handleDeleteRole}
        />
      </div>

      <RoleModal
        opened={modalHook.modalOpen}
        onClose={modalHook.closeModal}
        onSubmit={handleSubmit}
        control={formHook.control}
        permissions={permissionsHook.permissions}
        loadingPermissions={permissionsHook.loadingPermissions}
        isPermissionsError={permissionsHook.isPermissionsError}
        isSubmitting={handlerHook.isCreating || handlerHook.isUpdating}
        mode={modalHook.modalMode}
        refetchPermissions={permissionsHook.refetchPermissions}
      />

      <ConfirmModal
        opened={handlerHook.confirmOpen}
        onConfirm={handlerHook.handleConfirmDelete}
        onCancel={handlerHook.handleCancelDelete}
        title="Delete Role"
        message={
          handlerHook.pendingDelete
            ? `Are you sure you want to delete '${handlerHook.pendingDelete.name} & its associated permissions?'`
            : "Are you sure you want to delete this Role & its associated permissions?"
        }
        isLoading={handlerHook.isDeleting}
        confirmLabel={handlerHook.isDeleting ? "Deleting..." : "Yes, delete"}
        cancelLabel="Cancel"
      />
    </div>
  );
};

export default RolesTab;
